import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TEAM_META = {
  commanders: { label: 'Commanders', full: 'Washington Commanders', color: '#5A1414', path: '/commanders' },
  nationals: { label: 'Nationals', full: 'Washington Nationals', color: '#AB0003', path: '/nationals' },
  capitals: { label: 'Capitals', full: 'Washington Capitals', color: '#C8102E', path: '/capitals' },
  wizards: { label: 'Wizards', full: 'Washington Wizards', color: '#002B5C', path: '/wizards' },
  mystics: { label: 'Mystics', full: 'Washington Mystics', color: '#BF0A30', path: '/mystics' },
  dcunited: { label: 'DC United', full: 'DC United', color: '#000000', path: '/dcunited' },
  spirit: { label: 'Spirit', full: 'Washington Spirit', color: '#C4122E', path: '/spirit' },
  defenders: { label: 'Defenders', full: 'DC Defenders', color: '#C8102E', path: '/defenders' },
  dcsoccer: { label: 'DC Soccer', full: 'DC Soccer', color: '#000000', path: '/dcsoccer' },
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateString;
  }
};

export const ArticleImage = ({ article, className = '' }) => {
  const meta = TEAM_META[article.team] || TEAM_META.nationals;
  if (article.has_image) {
    return (
      <img
        src={`${API}/articles/${article.id}/image`}
        alt={article.title}
        className={`w-full h-full object-cover ${className}`}
        loading="lazy"
      />
    );
  }
  return (
    <div
      className="w-full h-full flex items-center justify-center p-2"
      style={{ backgroundColor: meta.color }}
    >
      <img
        src="https://customer-assets.emergentagent.com/job_dcsportshub/artifacts/fw8w9adx_DCSportsReport_Logo.png"
        alt={meta.label}
        className="max-h-[60%] max-w-[60%] object-contain opacity-90"
      />
    </div>
  );
};

export const ArticleCard = ({ article, showExcerpt = true }) => {
  const meta = TEAM_META[article.team] || TEAM_META.nationals;
  const excerpt = article.summary || (article.content ? article.content.substring(0, 140) + '…' : '');

  return (
    <Link
      to={`/article/${article.id}`}
      data-testid={`article-card-${article.id}`}
      className="group block"
    >
      <div className="aspect-video overflow-hidden border border-slate-200 bg-slate-100">
        <ArticleImage article={article} className="group-hover:scale-105 transition-transform duration-300" />
      </div>
      <div className="pt-3">
        <span
          className="text-xs font-bold uppercase tracking-[0.2em]"
          style={{ color: meta.color === '#000000' ? '#BF0A30' : meta.color }}
        >
          {meta.label}
        </span>
        <h3 className="font-serif-head font-bold text-lg text-slate-900 leading-snug mt-1 group-hover:underline decoration-2 underline-offset-2">
          {article.title}
        </h3>
        {showExcerpt && excerpt && (
          <p className="text-sm text-slate-600 leading-relaxed mt-1.5 line-clamp-2">{excerpt}</p>
        )}
        <p className="text-xs uppercase tracking-wide text-slate-500 mt-2">
          {article.author && <span>{article.author}</span>}
          {article.author && article.created_at && <span className="mx-1.5">·</span>}
          {article.created_at && <span>{formatDate(article.created_at)}</span>}
        </p>
      </div>
    </Link>
  );
};
